import { request } from "@/components/Joyspace/api/request";
import * as shortcuts from "./shortcuts";
import { BusinessType } from "../const";

export const shortcut = {
  add: (id: string) => {
    return shortcuts.add(id, BusinessType.Folder);
  },
  remove: (id: string) => {
    return shortcuts.remove(id, BusinessType.Folder);
  }
};

export function rename(id: string, value: string, isTeam?: boolean) {
  // if (isTeam) {
  //     return request({
  //         api: 'joyspace.spaceCategory.update',
  //         path: `/v1/categories/${id}`,
  //         method: 'PUT',
  //         body: {
  //             name: value,
  //         },
  //     });
  // }
  return request({
    api: "joyspace.folder.rename",
    path: `/v1/folders/${id}/rename`,
    method: "PUT",
    body: {
      name: value
    }
  });
}

export function remove(id: string, isTeam?: boolean) {
  // 去掉共享走不同接口
  // if (isTeam) {
  //     return request({
  //         api: 'joyspace.spaceCategory.remove',
  //         path: `/v1/categories/${id}`,
  //         method: 'DELETE',
  //     });
  // }
  return request({
    api: "joyspace.folder.remove",
    path: `/v1/folders/${id}`,
    method: "DELETE"
  })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
}

// 创建文件夹
export function create(id: string, name: string, description?: string) {
  // 去掉共享走不同接口增加描述
  // if (isTeam) {
  //     return request({
  //         api: 'joyspace.spaceCategory.create',
  //         path: `/v1/spaces/${id}/categories`,
  //         method: 'POST',
  //         body: {
  //             name,
  //         },
  //     });
  // }
  return request({
    api: "joyspace.folder.create",
    path: `/v1/folders`,
    method: "POST",
    body: {
      name,
      parent: id,
      description
    }
  });
}
// 批量创建文件夹
export function batchCreate(id: string, pathNames: String[]) {
  return request({
    api: "joyspace.folder.batchCreate",
    path: `/v1/folders/batchCreate`,
    method: "POST",
    body: {
      pathNames,
      parent: id
    }
  });
}
export function move(targetId: string, toId: string) {
  return request({
    api: "joyspace.folder.moveTo",
    path: `/v1/folders/${targetId}/moveTo`,
    method: "POST",
    body: {
      folderId: toId || ""
    }
  });
}

export function info(id: string) {
  return request({
    api: "joyspace.folder.get",
    path: `/v1/folders/${id}`
  });
}
export function infoWithAuth(id: string, parames?: any) {
  return request({
    api: "joyspace.folder.get",
    path: `/v1/folders/${id}`,
    params: {
      authFolder: id,
      ...parames
    }
  });
}

export function paths(categoryId: string) {
  return request({
    api: "joyspace.spaceCategory.get",
    path: `/v1/categories/${categoryId}`
  });
}
// 设置文件夹
export function setFolderApi(folderId: string, name: string, description?: string) {
  return request({
    api: "joyspace.folder.update",
    path: `/v1/folders/${folderId}/update`,
    method: "PUT",
    body: {
      name,
      description: description || ""
    }
  });
}

// 删除文件夹，不会出现在回收站
// 是否加入回收站 0:不加入, 1:加入
export function deleteFolder(folderId: string, addToTrash: 0 | 1) {
  return request({
    api: "joyspace.folder.remove",
    path: `/v1/folders/${folderId}?addToTrash=${addToTrash}`,
    method: "DELETE"
  });
}

// 根据文件夹名称搜索文件夹
export function searchFolder(name: string) {
  return request({
    api: "joyspace.folder.search",
    path: `/v1/folders/search/${name}`,
    method: "GET"
  })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
}

/**
 * 搜索文件类型
 *
 */
export function searchTypes() {
  return request({
    api: "joyspace.search.types",
    path: `/v1/search/types`,
    method: "GET"
  });
}
